<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6")
            BaseTextField(rules="required" v-model="form.id", label="Id")
          v-col(cols="12" sm="6")
            BaseDatePickerRange(rules="required" v-model="form.daterange", label="Fechas")
          v-col(cols="12" sm="6")
            BaseTextField(rules="required|host" v-model="form.url", label="Destino")
          v-col(cols="12").my-0.py-0
            v-btn.float-right(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingCreate") {{ translations.button.send }}

</template>

<script>

  export default {
    name: "OptinCreate",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() =>({
      form:{
        id: '',
        daterange: [],
        url: '',
      },
    }),
    computed:{
      loadingCreate() {
        return this.$store.state.statusCode.createOptin.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createOptin.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200) {
          this.$emit('successCreate');
        }
      },
    },
    methods:{
      getDateIsoString(date){
        const [day, month, year] = date.split('/');
        return new Date(year, month - 1, day).toISOString();
      },
      submitDataForm(){
        let formSend = {
          data: {
            id: this.form.id,
            startdate: this.getDateIsoString(this.form.daterange[0]),
            enddate: this.getDateIsoString(this.form.daterange[1]),
            url: this.form.url,
          }
        };
        this.$store.dispatch('createOptin', formSend);
      },
      clearFields(){
        this.form.id = '';
        this.form.daterange = [];
        this.form.url = '';
      },
    }
  }
</script>

<style lang="sass">
</style>